// extracted by mini-css-extract-plugin
export default {"label":"WorkBox_label__Mrw4k","labelInfo":"WorkBox_labelInfo__Y6Dul","overlayContainer":"WorkBox_overlayContainer__d0UdL"};